import { ActionTree, GetterTree, Module, MutationTree } from "vuex";
import { IAuth } from "@/@types/auth/auth";
import { UserRoles } from "@/api/AuthAPI/user-role";
import { getPayload } from "@/services/accessDecoder";

const state: IAuth = {
  access: localStorage.getItem("access") || null,
  refreshtoken: localStorage.getItem("refreshToken") || null,
  userRoles: getUserRol(localStorage.getItem("access")),
};

const getters: GetterTree<IAuth, IRootState> = {
  getUserRole: (state: IAuth) =>
    state.userRoles ? state.userRoles : localStorage.getItem("userRoles"),
  getAccess: (state: IAuth) =>
    state.access ? state.access : localStorage.getItem("access"),
  getRefreshToken: (state: IAuth) =>
    state.refreshtoken
      ? state.refreshtoken
      : localStorage.getItem("refreshToken"),
  isAuthorized(state): boolean {
    const token = localStorage.getItem("refreshToken");
    const auth = state.refreshtoken ? state.refreshtoken : token;
    if (!state.refreshtoken && token) state.refreshtoken = token;
    return auth ? true : false;
  },
};

const mutations: MutationTree<IAuth> = {
  setAccess: (state: IAuth, token: string) => {
    state.access = token;
    localStorage.setItem("access", token);
  },
  setRefreshToken: (state: IAuth, token: string) => {
    state.refreshtoken = token;
    localStorage.setItem("refreshToken", token);
  },
  setUserRoles: (state: IAuth, role: UserRoles) => {
    state.userRoles = role;
    localStorage.setItem("userRoles", role);
  },

  deleteAccessToken: (state: IAuth) => {
    state.access = null;
    localStorage.removeItem("access");
  },
  deleteRefreshToken: (state: IAuth) => {
    state.refreshtoken = null;
    localStorage.removeItem("refreshToken");
  },
  deleteUserRoles: (state: IAuth) => {
    state.userRoles = null;
    localStorage.removeItem("userRoles");
  },
};

const actions: ActionTree<IAuth, IRootState> = {
  setAccessToken({ commit }, token: string) {
    commit("setAccess", token);
  },
  setRefreshToken({ commit }, token: string) {
    commit("setRefreshToken", token);
  },
  setUserRoles({ commit }, role: string) {
    commit("setUserRoles", role);
  },
  onLogout({ commit }) {
    commit("deleteAccessToken");
    commit("deleteRefreshToken");
    commit("deleteUserRoles");
    commit("CHANGE_ROUTER", []);
    localStorage.removeItem("login");
  },
};

function getUserRol(access: string | null): string | null {
  if (!access) return null;
  let userRol: string | null = getPayload(access).rules;
  if (!userRol) userRol = localStorage.getItem("userRoles");
  return userRol;
}

export const auth: Module<IAuth, IRootState> = {
  state,
  mutations,
  actions,
  getters,
};
